export default "__VITE_ASSET__b6c140f9__"